import { drawerClasses } from '@mui/material';

export const muiDrawerOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				[`.${drawerClasses.paper}`]: {
					width: theme.tsGoUnit.tsUnitWidthAside,
					boxSizing: 'border-box',
					form: {
						padding: theme.tsGoUnit.tsUnit,
					},
				},
			};
		},
	},
};
